import instance from '@apis/instance';

const BASE_UPLOAD_URL = '/upload';

const IMAGE_UPLOAD_URL = `${BASE_UPLOAD_URL}/image`;
const uploadSingleImage = (bucketName: string, imageData: FormData) =>
  instance.post(`${IMAGE_UPLOAD_URL}/${bucketName}`, imageData);

const IMAGES_UPLOAD_URL = `${BASE_UPLOAD_URL}/images`;
const uploadMultipleImages = (bucketName: string, imagesData: FormData) =>
  instance.post(`${IMAGES_UPLOAD_URL}/${bucketName}`, imagesData);

export default {
  uploadSingleImage,
  uploadMultipleImages,
};
